import React from 'react';

const TOAST_DURATION = 5000;

const toastConfig = {
  success: { icon: 'fa-check-circle', title: 'Succès' },
  danger: { icon: 'fa-exclamation-circle', title: 'Erreur' },
  warning: { icon: 'fa-exclamation-triangle', title: 'Attention' },
  info: { icon: 'fa-info-circle', title: 'Information' },
};

const AdminToast = ({ message, type = 'info', onClose, duration = TOAST_DURATION }) => {
  const closeRef = React.useRef(onClose);
  const config = toastConfig[type] || toastConfig.info;

  React.useEffect(() => {
    closeRef.current = onClose;
  }, [onClose]);

  React.useEffect(() => {
    if (!message) return undefined;

    const timeout = window.setTimeout(() => {
      if (closeRef.current) closeRef.current();
    }, duration);

    return () => window.clearTimeout(timeout);
  }, [message, duration]);

  if (!message) return null;

  return (
    <div className={`admin-toast admin-toast-${type}`} role={type === 'danger' ? 'alert' : 'status'} aria-live="polite">
      <div className="admin-toast-icon"><i className={`fa ${config.icon}`} aria-hidden="true" /></div>
      <div className="admin-toast-content">
        <strong>{config.title}</strong>
        <span>{message}</span>
      </div>
      <button type="button" className="admin-toast-close" onClick={onClose} aria-label="Fermer la notification">×</button>
      <div className="admin-toast-progress" aria-hidden="true">
        <span style={{ animationDuration: `${duration}ms` }} />
      </div>
    </div>
  );
};

export default AdminToast;
